window.portalModule.factory 'ValidateJwtService', (Restangular, AuthService) ->

  restAngular = Restangular.withConfig (Configurer) ->
    Configurer.setBaseUrl(AuthService.getConfigData().PHR_AUTHN_ENDPOINT_URL_V3 + '/jwts')

  _validateJwtService = restAngular.all("")

  validate: ->
    return _validateJwtService.get('validate')
